import React, { useState } from "react";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import { Link } from "react-router-dom";
import LazyLoad from "react-lazyload";
const SchoolCabinet = () => {
  return (
    <>
      <Header />
      <div className="innerslide Admissionbg">
        <ul className="breadcrumb">
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>School Cabinet</li>
        </ul>
      </div>
      <div className="innersec cabinet">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <h1>School Cabinet</h1>
            </div>
            {/* <div className="topperssec">
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/KartikTiwari25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    Kartik Tiwari <span>Head Boy </span>
                  </p>
                  <p> X Moon </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/AnshikaVerma25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Anshika Verma <span> Head Girl </span>{" "}
                  </p>{" "}
                  <p> X Moon </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/AnshPatel25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Ansh Patel <span> Vice Head Boy </span>{" "}
                  </p>{" "}
                  <p> IX Sun </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/GauriGautam25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Gauri Gautam <span> Vice Head Girl </span>{" "}
                  </p>{" "}
                  <p> IX Moon </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/AbhinavSingh25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Abhinav Singh <span> Discipline Captain Boy </span>{" "}
                  </p>{" "}
                  <p> X Star </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/SatakshiSingh25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Satakshi Singh <span> Discipline Captain Girl</span>{" "}
                  </p>{" "}
                  <p> X Star </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/ShashankPandey25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Shashank Pandey{" "}
                    <span> Discipline Vice Captain Boy </span>{" "}
                  </p>{" "}
                  <p> IX Sun </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/SandhyaRajak25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Sandhya Rajak{" "}
                    <span> Discipline Vice Captain Girl </span>{" "}
                  </p>{" "}
                  <p> IX Star </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/SushantSingh25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Sushant Singh <span>Sports Captain Boy </span>{" "}
                  </p>{" "}
                  <p> X Sun </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/AnushkaPatel25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Anushka Patel <span> Sport Captain Girl </span>{" "}
                  </p>{" "}
                  <p> X Star </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/IshwarShrivastav25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Ishwar Shrivastav{" "}
                    <span> Sports Vice Captain Boy </span>{" "}
                  </p>{" "}
                  <p> IX Star </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/SaraswatiJaiswal25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Saraswati Jaiswal{" "}
                    <span> Sports Vice Captain Girl </span>{" "}
                  </p>{" "}
                  <p> IX Star </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/GyanPrakashPatel25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Gyan Prakash Patel <span> Literary Captain Boy </span>{" "}
                  </p>{" "}
                  <p> X Moon </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/StutiPandey25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Stuti Pandey <span> Literary Captain Girl </span>{" "}
                  </p>{" "}
                  <p> X Moon </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/AnkitPandey25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Ankit Pandey <span> Cultural Captain Boy </span>{" "}
                  </p>{" "}
                  <p> IX Star </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/AnushkaJaiswal25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Anushka Jaiswal <span> Cultural Captain Girl </span>{" "}
                  </p>{" "}
                  <p> X Sun</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/AakashTiwari25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Aakash Tiwari <span> Band Captain Boy </span>{" "}
                  </p>{" "}
                  <p>IX Star </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/SanskritiShukla25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Sanskriti Shukla <span>Band Captain Girl </span>{" "}
                  </p>{" "}
                  <p> IX Sun </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/SatyamSingh25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Satyam Singh <span> Band Vice Captain Boy </span>{" "}
                  </p>{" "}
                  <p> IX Sun </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/KajalRajak25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Kajal Rajak <span> Band Vice Captain </span>{" "}
                  </p>{" "}
                  <p>IX Star </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/GauravSingh25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Gaurav Singh <span> Gandhi House Captain </span>{" "}
                  </p>{" "}
                  <p> X Moon </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/SakshiPandey25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Sakshi Pandey <span> Gandhi House Captain Girl </span>{" "}
                  </p>{" "}
                  <p> X Sun </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/AnmolTripathi25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Anmol Tripathi <span> Gandhi House Vice Captain </span>{" "}
                  </p>{" "}
                  <p> IX Sun </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/PihuTiwari25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Pihu Tiwari{" "}
                    <span>Gandhi House Vice Captain Girl </span>{" "}
                  </p>{" "}
                  <p> IX Star </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/AbyudhayaSingh25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Abyudhaya Singh <span> Alphonsa House Captain </span>{" "}
                  </p>{" "}
                  <p> X Star </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/ManyaPandey25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Manya Pandey <span> Alphonsa House Captain Girl </span>{" "}
                  </p>{" "}
                  <p>X Sun </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/ShreyashSingh25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Shreyash Singh{" "}
                    <span>Aophonsa House Vice Captain </span>{" "}
                  </p>{" "}
                  <p> IX Sun </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/SakshiSingh25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Sakshi Singh{" "}
                    <span> Alphonsa House Vice Captain Girl </span>{" "}
                  </p>{" "}
                  <p> IX Star </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/AyanshPandey25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Ayansh Pandey <span>Kalam House Captain </span>{" "}
                  </p>{" "}
                  <p> X Moon </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/ShreyashiSingh25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Shreyashi Singh <span>Kalam House Captain Girl </span>{" "}
                  </p>{" "}
                  <p> X Sun </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/RudraSingh25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Rudra Singh <span> Kalam House Vice Captain </span>{" "}
                  </p>{" "}
                  <p> IX Star </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/kritikaSingh25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    kritika Singh{" "}
                    <span> Kalam House Vice Captain Girl </span>{" "}
                  </p>{" "}
                  <p> IX Sun </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/ShantanuSingh25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Shantanu Singh{" "}
                    <span> Mother Teresa House Captain </span>{" "}
                  </p>{" "}
                  <p> X Moon </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/TanviVishwakarma25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Tanvi Vishwakarma{" "}
                    <span> Mother Teresa House Captain </span>{" "}
                  </p>{" "}
                  <p>X Star </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/PrasannShukla25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Prasann Shukla{" "}
                    <span>Mother Teresa House Vice Capatain </span>{" "}
                  </p>{" "}
                  <p>IX Moon </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/StutiMishra25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Stuti Mishra{" "}
                    <span> Mother Teresa House Vice Captain Girl </span>{" "}
                  </p>{" "}
                  <p> IX Sun </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/KanishkTiwari25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Kanishk Tiwari <span> Science Club Captain </span>{" "}
                  </p>{" "}
                  <p> X Sun </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/VrindaMishra25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Vrinda Mishra <span> Science Club Captain Girl </span>{" "}
                  </p>{" "}
                  <p> X Star </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/Rudra-PratapMishra25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Rudra Pratap Mishra <span> Maths Club Captain </span>{" "}
                  </p>{" "}
                  <p> X Moon </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/JahanviGupta25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Jahanvi Gupta <span>Maths Club Captain Girl </span>{" "}
                  </p>{" "}
                  <p>IX Sun </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/Pratham-Chaturvedi25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Pratham Chaturvedi<span>Cyber Club Captain </span>{" "}
                  </p>{" "}
                  <p> IX Moon </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/Prinshika-Singh25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Prinshika Singh <span> Cyber Club Captain Girl</span>{" "}
                  </p>{" "}
                  <p>X Moon </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/Anurag-Sharma25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Anurag Sharma{" "}
                    <span> Social Science Club Captain </span>{" "}
                  </p>{" "}
                  <p> IX Moon </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/Anushri-Srivastava25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Anushri Srivastava{" "}
                    <span> Social Science Club Girl </span>{" "}
                  </p>{" "}
                  <p> IX Star </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/UjjwalSingh25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Ujjwal Singh <span> Language Club Captain </span>{" "}
                  </p>{" "}
                  <p> IX Moon </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/Akriti-Singh25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Akriti Singh <span> Language Club Captain girl </span>{" "}
                  </p>{" "}
                  <p>IX Moon </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/ShubhGautam25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Shubh Gautam <span>Social Service Club Captain </span>{" "}
                  </p>{" "}
                  <p> X Sun </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/PoornimaSingh25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Poornima Singh{" "}
                    <span>Social Sevice Club Captain Girl </span>{" "}
                  </p>{" "}
                  <p> IX </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/Shivam-Jaiswal25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Shivam Jaiswal <span> Art Club Captain </span>{" "}
                  </p>{" "}
                  <p> X Moon </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/Sagun-Jaiswal25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Sagun Jaiswal <span> Art Club Captain Girl </span>{" "}
                  </p>{" "}
                  <p> IX Star </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/Ansh-Tiwari25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Ansh Tiwari <span> Eco Club Captain </span>{" "}
                  </p>{" "}
                  <p>IX Moon </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/Bhavya-Tiwari25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Bhavya Tiwari <span> Eco Club Captain Club </span>{" "}
                  </p>{" "}
                  <p>IX Star </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/PragyanSingh25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Pragyan Singh <span>Swacchata Club Captain </span>{" "}
                  </p>{" "}
                  <p> X Star </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/PavaniChaturvedi25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Pavani Chaturvedi{" "}
                    <span> Swacchata Club Captain Girl </span>{" "}
                  </p>{" "}
                  <p>IX Moon </p>
                </div>
              </div>
            </div> */}
            <div className="topperssec">
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/Cabinet-1.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    Ansh Patel<span>School Captain </span>
                  </p>
                  <p> X Star</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/Cabinet-2.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Bhavya Tiwari <span> School Captain </span>{" "}
                  </p>{" "}
                  <p> X Sun </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/Cabinet-3.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Rudra Pratap Singh   <span> School Vice Captain </span>{" "}
                  </p>{" "}
                  <p> X Moon </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/Cabinet-4.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Pratham Chaturvedi  <span> Discipline Captain </span>{" "}
                  </p>{" "}
                  <p> X Star  </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/Cabinet-5.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Ananya Singh<span> Discipline Vice Captain </span>{" "}
                  </p>{" "}
                  <p> IX Sun </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/Cabinet-6.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Saraswati Jaiswal   <span> Sports Captain</span>{" "}
                  </p>{" "}
                  <p> X Moon </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/Cabinet-7.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Nirbhay Singh {" "}
                    <span> Sports Vice Captain  </span>{" "}
                  </p>{" "}
                  <p> IX Moon </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/Cabinet-8.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Snehal Dwivedi  {" "}
                    <span> Literary Captain </span>{" "}
                  </p>{" "}
                  <p> IX Star </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/Cabinet-9.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Tanvi Gupta   <span>Literary Vice Captain </span>{" "}
                  </p>{" "}
                  <p> IX Sun </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/Cabinet-10.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Stuti Mishra <span> Cultural Captain </span>{" "}
                  </p>{" "}
                  <p> X Moon</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/Cabinet-11.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Ansh Kumar Patel  {" "}
                    <span> Cultural Vice Captain</span>{" "}
                  </p>{" "}
                  <p> VIII Star</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/Cabinet-12.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Ankit Pandey  {" "}
                    <span> Band Captain </span>{" "}
                  </p>{" "}
                  <p> X Sun</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/Cabinet-13.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Samriddhi Singh  <span> Band Vice Captain  </span>{" "}
                  </p>{" "}
                  <p> VIII </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/Cabinet-14.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Gaurav Singh   <span> Mother Teresa House Captain </span>{" "}
                  </p>{" "}
                  <p> X Sun</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/Cabinet-15.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Jahnavi Gupta <span> Mother Teresa House Vice Captain </span>{" "}
                  </p>{" "}
                  <p> X Sun</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/Cabinet-16.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Shashank Pandey   <span> Alphonsa House Captain </span>{" "}
                  </p>{" "}
                  <p> X Sun</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/Cabinet-17.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Ishwar Shrivastav<span> Alphonsa Huse Vice Captain </span>{" "}
                  </p>{" "}
                  <p> X Sun</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/Cabinet-18.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Divyanshi Pandey  <span> Gandhi House Captain</span>{" "}
                  </p>{" "}
                  <p> IX Star</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/Cabinet-19.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Jatin Pandey   <span> Gandhi House Vice Captain</span>{" "}
                  </p>{" "}
                  <p> VIII Moon </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/Cabinet-20.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Samriddhi Singh    <span> Kalam House Captain</span>{" "}
                  </p>{" "}
                  <p> IX Sun</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/Cabinet-21.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Shourya Kaithwas  <span> Kalam House Vice Captain</span>{" "}
                  </p>{" "}
                  <p> IX Sun</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/Cabinet-22.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Shagun Jaiswal   <span> Science Club Captain</span>{" "}
                  </p>{" "}
                  <p> X Moon </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/Cabinet-23.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Trisha Tripathi    <span> Maths Club Captain</span>{" "}
                  </p>{" "}
                  <p> IX Star  </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/Cabinet-24.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Daksh Dubey   <span> Social Science Club Captain</span>{" "}
                  </p>{" "}
                  <p> IX Sun </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/Cabinet-25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Sandhya Rajak     <span> Language Club Captain</span>{" "}
                  </p>{" "}
                  <p> X Star</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/Cabinet-26.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Ritika Singh      <span> Social Service Club Captain</span>{" "}
                  </p>{" "}
                  <p> IX Star</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/Cabinet-27.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Akshansh Tripathi    <span> Art Club Captain</span>{" "}
                  </p>{" "}
                  <p>VIII</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/Cabinet-28.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Ujjawal Singh Chauhan <span> Swacchata Club Captain</span>{" "}
                  </p>{" "}
                  <p>X Star </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default SchoolCabinet;
